import cx from 'classnames'

export const Row = ({ children, className, noGutters = false, ...props }) => (
  <div className={cx('tw:flex tw:flex-wrap', !noGutters && 'tw:-mx-3', className)} {...props}>
    {children}
  </div>
)
